document.addEventListener("DOMContentLoaded", () => {
  const btnDesktop = document.getElementById("download-pdf-btn");
  const btnMobile = document.getElementById("download-pdf-btn_mobile");
  const techSheetContainer = document.getElementById("tech-sheet-container");

// Move the PDF markup outside the desktop-only container.
// It remains hidden until a PDF is generated.
if (techSheetContainer) {
  document.body.appendChild(techSheetContainer);
}

  console.log(btnDesktop, btnMobile, "buttons loaded");

  if (!btnDesktop && !btnMobile) return;

  if (window.pdfHandlerInitialized) {
    console.log("PDF handlers already initialized — skipping duplicate setup.");
    return;
  }
  window.pdfHandlerInitialized = true;

  if (window.shopifyProduct) {
    console.log("Shopify Product Data:", window.shopifyProduct);
    const product = window.shopifyProduct;
    if (product.featured_image) {
      const imageUrl = product.featured_image.startsWith("//")
        ? `https:${product.featured_image}`
        : product.featured_image.startsWith("http")
        ? product.featured_image
        : `https://${product.featured_image}`;

      const imgEl = document.querySelector(".main-product-image img");
      if (imgEl) imgEl.src = imageUrl;
    }
  } else {
    console.warn("Product data not found. Did you add {{ product | json }}?");
  }

  const generatePDF = async (source) => {
  const container = document.getElementById("tech-sheet-container");
  const sheet = document.getElementById("tech-sheet");

  if (!container || !sheet) {
    console.error("Tech sheet markup was not found.");
    return;
  }

  const originalContainerDisplay = container.style.display;
  const originalSheetDisplay = sheet.style.display;

  try {
    container.style.display = "block";
    sheet.style.display = "block";

    // Give the browser time to render the sheet and its images.
    await new Promise((resolve) =>
      requestAnimationFrame(() => requestAnimationFrame(resolve))
    );

    const images = Array.from(sheet.querySelectorAll("img"));

    await Promise.all(
      images.map((image) => {
        if (image.complete) return Promise.resolve();

        return new Promise((resolve) => {
          image.addEventListener("load", resolve, { once: true });
          image.addEventListener("error", resolve, { once: true });
        });
      })
    );

    const opt = {
      margin: [0, 0, 0, 0],

      filename: window.shopifyProduct
        ? `${window.shopifyProduct.title
            .replace(/[^\w\s]/g, "")
            .replace(/\s+/g, "_")}_Tech_Sheet.pdf`
        : "product_tech_sheet.pdf",

      html2canvas: {
        // Keep the existing desktop quality.
        // Reduce only the mobile scale to avoid mobile memory failures.
        scale: source === "mobile" ? 2 : 5,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        scrollX: 0,
        scrollY: 0,
      },

      jsPDF: {
        unit: "px",
        format: [1545, 2000],
        orientation: "portrait",
      },

      pagebreak: {
        mode: ["css", "legacy"],
      },
    };

    await html2pdf()
      .set(opt)
      .from(sheet)
      .save();
  } catch (error) {
    console.error("The tech sheet could not be generated:", error);
  } finally {
    sheet.style.display = originalSheetDisplay || "none";
    container.style.display = originalContainerDisplay || "none";
  }
};

  if (btnDesktop) {
    btnDesktop.addEventListener("click", (e) => {
      e.stopPropagation();
      if (window.innerWidth > 768) {
        console.log("desktop");
        generatePDF("desktop");
      }
    });
  }

  if (btnMobile) {
    btnMobile.addEventListener("click", (e) => {
      e.stopPropagation();
      if (window.innerWidth <= 768) {
        console.log("mobile");
        generatePDF("mobile");
      }
    });
  }
});
